import { combineReducers } from "redux";
import  {loginReducer}  from "./loginReducer";
import { interactionReducer } from "./interactionReducer";

const reducers = combineReducers({
    login:loginReducer,
    interactions: interactionReducer
});


export default reducers